import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const PolitiqueConfidentialite = () => {
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-6 py-6">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-gray-600 hover:text-blue-600 transition-colors"
            data-testid="back-to-home-link"
          >
            <ArrowLeft className="w-4 h-4" />
            Retour à l'accueil
          </Link>
        </div>
      </header>
      
      <main className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-8 font-['Manrope']">
          Politique de confidentialité
        </h1>
        
        <div className="prose prose-gray max-w-none space-y-8">
          <p className="text-gray-600 leading-relaxed">
            Performance Transmission collecte des données via son formulaire de contact uniquement. 
            Aucun cookie de tracking n'est utilisé. Les données financières et fiscales partagées 
            lors des prestations sont traitées avec la plus stricte confidentialité.
          </p>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4 font-['Manrope']">
              2.1 Responsable du traitement
            </h2>
            <p className="text-gray-600 leading-relaxed">
              Performance Transmission Sàrl, Tolochenaz VD, Suisse — compta@performancetransmission.ch
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4 font-['Manrope']">
              2.2 Données collectées via le formulaire de contact
            </h2>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>Nom et prénom (obligatoire)</li>
              <li>Secteur d'activité (obligatoire)</li>
              <li>Description du besoin (obligatoire)</li>
              <li>Adresse email (obligatoire)</li>
              <li>Numéro de téléphone (optionnel)</li>
            </ul>
            <p className="text-gray-600 leading-relaxed mt-4">
              Une prise de rendez-vous via Calendly peut également être proposée.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4 font-['Manrope']">
              2.3 Données traitées dans le cadre des prestations
            </h2>
            <p className="text-gray-600 leading-relaxed">
              Dans le cadre de la prestation de services fiduciaires, des données financières, 
              fiscales et personnelles sensibles peuvent être traitées (revenus, charges, bilans, 
              déclarations fiscales). Ces données sont traitées exclusivement dans le cadre légal 
              de la prestation et couvertes par le secret professionnel.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4 font-['Manrope']">
              2.4 Finalités du traitement
            </h2>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>Traitement et qualification de votre demande de contact</li>
              <li>Réalisation des prestations fiduciaires commandées</li>
              <li>Obligations légales (conservation des documents comptables et fiscaux)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4 font-['Manrope']">
              2.5 Base légale (LPD)
            </h2>
            <p className="text-gray-600 leading-relaxed">
              Le traitement est fondé sur votre consentement (formulaire de contact), l'exécution 
              du contrat de prestation, et les obligations légales applicables aux fiduciaires suisses.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4 font-['Manrope']">
              2.6 Durée de conservation
            </h2>
            <p className="text-gray-600 leading-relaxed">
              Données de contact non converties : 12 mois. Documents comptables et fiscaux : 10 ans 
              conformément à l'art. 958f CO (Code des obligations suisse). Déclarations fiscales : 10 ans.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4 font-['Manrope']">
              2.7 Confidentialité et secret professionnel
            </h2>
            <p className="text-gray-600 leading-relaxed">
              Performance Transmission Sàrl est soumise au secret professionnel. Toutes les informations 
              financières et personnelles confiées dans le cadre des prestations sont strictement 
              confidentielles et ne sont jamais divulguées à des tiers sans votre accord écrit, 
              sauf obligation légale.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4 font-['Manrope']">
              2.8 Vos droits (LPD)
            </h2>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>Droit d'accès à vos données</li>
              <li>Droit de rectification</li>
              <li>Droit à l'effacement (dans les limites des obligations légales de conservation)</li>
              <li>Droit d'opposition</li>
            </ul>
            <p className="text-gray-600 leading-relaxed mt-4">
              Contact : <a href="mailto:compta@performancetransmission.ch" className="text-blue-600 hover:text-blue-700">compta@performancetransmission.ch</a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4 font-['Manrope']">
              2.9 Cookies
            </h2>
            <p className="text-gray-600 leading-relaxed">
              Le site n'utilise pas de cookies de tracking ou publicitaires. Seuls des cookies 
              techniques strictement nécessaires au fonctionnement peuvent être utilisés.
            </p>
          </section>
        </div>
      </main>
      
      <footer className="border-t border-gray-200 py-8">
        <div className="max-w-4xl mx-auto px-6 text-center text-gray-500 text-sm">
          © 2025 Performance Transmission Sàrl. Tous droits réservés.
        </div>
      </footer>
    </div>
  );
};

export default PolitiqueConfidentialite;
